import React from 'react';
import i18n from '@nextroll/ar-i18n';
import { Link } from '@nextroll/ar-container-app';

export const WorkflowNotFound = () => {
    const workflowsUrl = '/workflows';
    const contactUrl = 'https://www.adroll.com/about/contact';

    return (
        <div className='page-not-found text-center'>
            <i className='page-not-found-icon ar-icon ar-icon-frown' />
            <h3 className='page-not-found-title'>
                { i18n.gettext('The page you were looking for doesn\'t exist') }
                <br />
            </h3>
            <h5 className='page-not-found-subtitle'>
                {
                    i18n.gettext(
                        'You may have mistyped the address or the page may have been deleted.',
                        {
                            Link: <Link to={ contactUrl } />,
                        }
                    )
                }
            </h5>
            <div className='page-not-found-buttons'>
                <button
                    className='btn btn-default buyflow-form-button page-not-found-go-to-dash'
                    type='button'
                >
                    <Link to={ workflowsUrl }>{ i18n.gettext('Go To Workflows') }</Link>
                </button>
            </div>
        </div>
    );
};
